import React from 'react';
import { FaEdit } from 'react-icons/fa';

/**
 * Modal for editing a single invoice line item (quantity, prices, VAT).
 * Prices auto-recalculate via handleEditFieldChange from the hook.
 */
const EditItemModal = ({
  editingItem,
  editFormData,
  onFieldChange,
  onSave,
  onClose
}) => {
  if (!editingItem) return null;

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      zIndex: 1000
    }}>
      <div style={{
        backgroundColor: 'var(--card-bg)', borderRadius: '0.5rem',
        boxShadow: '0 0.5rem 1rem rgba(0, 0, 0, 0.15)',
        maxWidth: '600px', width: '90%', maxHeight: '90vh', overflow: 'auto'
      }}>
        {/* Header */}
        <div style={{
          padding: '1rem 1.5rem', borderBottom: '1px solid var(--border)',
          display: 'flex', justifyContent: 'space-between', alignItems: 'center'
        }}>
          <h5 style={{ margin: 0, color: 'var(--text)', fontWeight: '600' }}>
            <FaEdit style={{ marginRight: '0.5rem' }} />
            Edytuj pozycje faktury
          </h5>
          <button
            onClick={onClose}
            style={{  background: 'none', fontSize: '1.5rem', cursor: 'pointer', color: 'var(--text-muted)' }}
          >
            &times;
          </button>
        </div>

        {/* Body */}
        <div style={{ padding: '1.5rem' }}>
          <div style={{ marginBottom: '1rem' }}>
            <p style={{ fontWeight: '600', marginBottom: '0.5rem' }}>
              {editingItem.nazwa_produktu}
            </p>
            {editingItem.kod_produktu && (
              <p style={{ fontSize: '0.875rem', color: 'var(--text-muted)', margin: 0 }}>
                Kod: {editingItem.kod_produktu}
              </p>
            )}
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
            <Field label="Ilosc">
              <input
                type="number" step="1" min="1"
                value={editFormData.ilosc}
                onChange={(e) => onFieldChange('ilosc', e.target.value)}
                style={inputStyle}
              />
            </Field>

            <Field label="Stawka VAT (%)">
              <select
                value={editFormData.stawka_vat}
                onChange={(e) => onFieldChange('stawka_vat', e.target.value)}
                style={inputStyle}
              >
                <option value="23">23%</option>
                <option value="8">8%</option>
                <option value="5">5%</option>
                <option value="0">0%</option>
              </select>
            </Field>

            <Field label="Cena netto">
              <input
                type="number" step="0.01"
                value={editFormData.cena_netto}
                onChange={(e) => onFieldChange('cena_netto', e.target.value)}
                style={inputStyle}
              />
            </Field>

            <Field label="Cena brutto">
              <input
                type="number" step="0.01"
                value={editFormData.cena_brutto}
                onChange={(e) => onFieldChange('cena_brutto', e.target.value)}
                style={inputStyle}
              />
            </Field>

            <Field label="Wartosc netto (wyliczona)">
              <input
                type="number" step="0.01"
                value={editFormData.wartosc_netto}
                readOnly
                style={{ ...inputStyle, backgroundColor: 'var(--border)' }}
              />
            </Field>

            <Field label="Wartosc brutto (wyliczona)">
              <input
                type="number" step="0.01"
                value={editFormData.wartosc_brutto}
                readOnly
                style={inputStyle}
              />
            </Field>
          </div>
        </div>

        {/* Footer */}
        <div style={{
          padding: '1rem 1.5rem', borderTop: '1px solid var(--border)',
          display: 'flex', justifyContent: 'flex-end', gap: '0.5rem'
        }}>
          <button
            onClick={onClose}
            style={{
              padding: '6px 12px', border: '1px solid var(--text-muted)',
              backgroundColor: 'var(--bg)',
              color: 'var(--text-secondary)', cursor: 'pointer', fontSize: '12px'
            }}
          >
            Anuluj
          </button>
          <button
            onClick={onSave}
            style={{
              padding: '6px 12px', border: '1px solid var(--info)', color: 'var(--info)' , cursor: 'pointer',
              fontSize: '12px', fontWeight: '500'
            }}
          >
            Zapisz zmiany
          </button>
        </div>
      </div>
    </div>
  );
};

const inputStyle = {
  width: '100%',
  padding: '0.5rem',
  border: '1px solid var(--border)',
  borderRadius: '0.375rem'
};

const Field = ({ label, children }) => (
  <div>
    <label style={{ display: 'block', marginBottom: '0.5rem', fontSize: '0.875rem', fontWeight: '500' }}>
      {label}
    </label>
    {children}
  </div>
);

export default EditItemModal;
